/* eslint-disable no-param-reassign */
import { produce } from 'immer';

export default (set, get) => set(produce(get(), (draft) => {
  if (!draft.design) {
    draft.design = {};
  }
  draft.design.selectedProduct = null;
  draft.design.selectedVisualizerStackId = null;
}), false, { type: 'RESET_SELECTED' });
